<div class="p-4 md:p-8 bg-[#F3F4F6] dark:bg-slate-900 min-h-screen   text-slate-600 dark:text-slate-300"
    (click)="closeDropdowns()">

    <!-- Title -->
    <div class="mb-5 animate-fade-in-up">
        <button (click)="onCancel()"
            class="mb-3 flex items-center gap-1 text-sm font-bold text-slate-400 hover:text-amber-500 transition-colors">
            <span class="material-icons text-base">arrow_back</span>
            กลับรายการรายได้
        </button>
        <h2 class="text-xl font-bold text-gray-800 dark:text-slate-100">เพิ่มรายได้ (Add Revenue)</h2>
        <p class="text-sm text-gray-500 dark:text-slate-400 mt-1">บันทึกข้อมูลรายได้อื่นๆ ของระบบ</p>
    </div>

    <!-- Main Card -->
    <div class="bg-white dark:bg-slate-800 xl:rounded-xl shadow-sm border border-gray-200 dark:border-slate-700 overflow-hidden animate-fade-in-up"
        style="animation-delay: 0.1s;">

        <!-- Section 1: Top Selection -->
        <div
            class="p-4 md:p-5 bg-gradient-to-br from-white/80 to-slate-50/80 dark:from-slate-800/80 dark:to-slate-900/80 backdrop-blur-sm relative border-b border-slate-100 dark:border-slate-800/50 z-50">
            <!-- Decorative Background Element -->
            <div class="absolute inset-0 overflow-hidden pointer-events-none rounded-t-xl">
                <div class="absolute -top-24 -right-24 w-64 h-64 bg-amber-400/10 rounded-full blur-3xl"></div>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 relative z-10 w-full">
                <div class="relative w-full z-20">
                    <ng-container *ngTemplateOutlet="selectField; context: { 
                        label: 'สถานที่ (Location)', 
                        key: 'locations', 
                        options: locationOptions, 
                        selected: selectedLocationId, 
                        icon: 'place', 
                        placeholder: '-- เลือกสถานที่ --',
                        disabled: isSiteLocked
                    }"></ng-container>
                </div>

                <div class="relative w-full z-10">
                    <ng-container *ngTemplateOutlet="selectField; context: { 
                        label: 'ลูกค้า (Customer)', 
                        key: 'customers', 
                        options: customerOptions, 
                        selected: selectedCustomerId, 
                        icon: 'people', 
                        placeholder: '-- เลือกลูกค้า --',
                        disabled: false
                    }"></ng-container>
                </div>
            </div>
        </div>

        <!-- Section 2: Financial Details & Tax -->
        <div class="p-4 md:p-5 grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 bg-slate-50/30 dark:bg-slate-900/30 relative z-40 animate-fade-in-up"
            style="animation-delay: 0.15s;">

            <!-- Left Column: Settings -->
            <div class="space-y-5 md:space-y-6 flex flex-col justify-start">

                <!-- Revenue Type Dropdown (Custom to include search) -->
                <div class="relative w-full z-[60]">
                    <label
                        class="block text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-1.5">
                        ประเภทรายได้ (Revenue Type) <span class="text-rose-500">*</span>
                    </label>
                    <div class="relative group" (click)="$event.stopPropagation();">
                        <button type="button" (click)="toggleDropdown('revenues', $event)"
                            class="w-full flex items-center justify-between px-3 py-2 bg-white dark:bg-slate-800 border-2 rounded-xl text-left transition-all duration-200 focus:outline-none focus:ring-4 focus:ring-amber-500/10 shadow-[0_2px_10px_-3px_rgba(0,0,0,0.05)] text-[13px] font-medium min-h-[40px]"
                            [ngClass]="openDropdown === 'revenues' ? 'border-amber-400 dark:border-amber-500 ring-4 ring-amber-500/10 shadow-sm' : 'border-slate-200 dark:border-slate-700 hover:border-amber-400 dark:hover:border-amber-500'">
                            <div class="flex items-center gap-2 limit-text w-full">
                                <div class="w-6 h-6 rounded-md flex items-center justify-center transition-colors shadow-sm flex-shrink-0"
                                    [ngClass]="selectedRevenueId !== null ? 'bg-amber-100 dark:bg-amber-900/40 text-amber-600 dark:text-amber-400' : 'bg-slate-100 dark:bg-slate-700 text-slate-400'">
                                    <span class="material-icons text-[14px]">category</span>
                                </div>
                                <span class="truncate block overflow-hidden text-ellipsis whitespace-nowrap"
                                    style="max-width: calc(100% - 24px);"
                                    [ngClass]="selectedRevenueId !== null ? 'text-slate-700 dark:text-slate-200' : 'text-slate-400 dark:text-slate-500'">
                                    {{ getOptionName('revenues', selectedRevenueId) || '-- เลือกประเภทรายได้ --' }}
                                </span>
                            </div>
                            <span
                                class="material-icons text-slate-400 transition-transform duration-300 text-[18px] ml-1 flex-shrink-0"
                                [ngClass]="{'rotate-180 text-amber-500': openDropdown === 'revenues'}">expand_more</span>
                        </button>

                        <div *ngIf="openDropdown === 'revenues'"
                            class="absolute z-[100] w-full mt-1.5 bg-white/95 dark:bg-slate-800/95 backdrop-blur-xl border border-slate-200/80 dark:border-slate-700/80 rounded-xl shadow-[0_10px_40px_-10px_rgba(0,0,0,0.15)] py-2 max-h-64 flex flex-col transform opacity-100 scale-100 transition-all origin-top animate-fade-in-up">

                            <!-- Search box -->
                            <div class="px-3 pb-2 border-b border-slate-100 dark:border-slate-700/50">
                                <div class="relative">
                                    <input type="text" [value]="revenueSearchTerm" (input)="onSearchRevenue($event)"
                                        placeholder="ค้นหาประเภทรายได้..."
                                        class="w-full pl-9 pr-3 py-1.5 bg-slate-50 dark:bg-slate-900/50 border border-slate-200 dark:border-slate-700 rounded-lg text-xs outline-none focus:border-amber-400 transition-colors text-slate-700 dark:text-slate-200">
                                    <span
                                        class="material-icons text-[16px] text-slate-400 absolute left-3 top-1/2 -translate-y-1/2">search</span>
                                </div>
                            </div>

                            <div class="overflow-y-auto custom-scrollbar flex-1 pt-1">
                                <button *ngIf="revenueOptions.length === 0" disabled
                                    class="w-full text-left px-3 py-2 text-[12px] text-slate-400 italic">
                                    ไม่พบข้อมูลที่ค้นหา
                                </button>
                                <button *ngFor="let option of revenueOptions"
                                    (click)="selectOption('revenues', option.value)"
                                    class="w-full text-left px-3 py-2.5 text-[12px] transition-colors flex items-center justify-between group"
                                    [ngClass]="selectedRevenueId === option.value ? 'bg-amber-50/80 dark:bg-amber-900/20 text-amber-700 dark:text-amber-400 font-bold' : 'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 font-medium'">
                                    <span class="truncate pr-2 block overflow-hidden text-ellipsis">{{ option.label
                                        }}</span>
                                    <span *ngIf="selectedRevenueId === option.value"
                                        class="material-icons text-[16px] text-amber-500 animate-scale-up flex-shrink-0">check_circle</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Financial Block -->
                <div
                    class="space-y-4 md:space-y-5 bg-white dark:bg-slate-800 rounded-2xl p-4 md:p-5 border border-slate-100 dark:border-slate-700/60 shadow-sm relative overflow-visible z-50 h-max flex-1">
                    <h3
                        class="text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-1 flex items-center gap-2">
                        <span class="material-icons text-sm">payments</span>
                        ข้อมูลการชำระเงิน (Financial)
                    </h3>

                    <!-- Invoice ID -->
                    <div class="relative z-50">
                        <ng-container *ngTemplateOutlet="selectField; context: { 
                            label: 'Invoice', 
                            key: 'invoices', 
                            options: invoiceOptions, 
                            selected: selectedInvoiceId, 
                            icon: 'receipt_long', 
                            placeholder: 'เลือก Invoice',
                            disabled: false,
                            required: false
                        }"></ng-container>
                    </div>

                    <!-- Payment Type & Bank -->
                    <div class="grid grid-cols-1 gap-5">
                        <div class="relative z-40">
                            <ng-container *ngTemplateOutlet="selectField; context: { 
                                label: 'ประเภทชำระเงิน', 
                                key: 'paymentTypes', 
                                options: paymentTypeOptions, 
                                selected: selectedPaymentTypeId, 
                                icon: 'account_balance_wallet', 
                                placeholder: '-- เลือก --',
                                disabled: false
                            }"></ng-container>
                        </div>

                        <div *ngIf="selectedPaymentTypeId?.toString() === '3'" class="animate-fade-in-up relative z-30">
                            <ng-container *ngTemplateOutlet="selectField; context: { 
                                label: 'ธนาคาร', 
                                key: 'banks', 
                                options: bankOptions, 
                                selected: selectedBankId, 
                                icon: 'account_balance', 
                                placeholder: '-- เลือกธนาคาร --',
                                disabled: false
                            }"></ng-container>
                        </div>
                    </div>

                    <!-- Amount -->
                    <div class="relative z-20 mt-4">
                        <label
                            class="block text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-1.5">
                            {{ amountFieldHint }} <span class="text-rose-500">*</span>
                        </label>
                        <div class="relative">
                            <div
                                class="absolute left-3 top-1/2 -translate-y-1/2 w-8 h-8 rounded-lg bg-amber-100 dark:bg-amber-900/30 text-amber-600 dark:text-amber-400 flex items-center justify-center">
                                <span class="material-icons text-[18px]">attach_money</span>
                            </div>
                            <input type="number" [(ngModel)]="feeAmount"
                                class="w-full pl-14 pr-12 py-2 bg-white dark:bg-slate-800 border-2 border-slate-200 dark:border-slate-700 rounded-xl outline-none focus:ring-4 focus:ring-amber-500/10 focus:border-amber-400 dark:focus:border-amber-500 font-bold text-lg text-slate-800 dark:text-slate-100 transition-all placeholder:font-normal placeholder:text-slate-300 dark:placeholder:text-slate-600"
                                placeholder="0.00">
                            <span
                                class="absolute right-4 top-1/2 -translate-y-1/2 text-slate-400 dark:text-slate-500 font-bold text-[13px]">บาท</span>
                        </div>

                        <div *ngIf="feeAmount > 0 && selectedRevenueId"
                            class="mt-3 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-900/40 p-3 space-y-2">
                            <div class="flex justify-between text-[12px]">
                                <span class="text-slate-500 dark:text-slate-400">รวมเป็นเงิน (Subtotal)</span>
                                <span class="font-bold text-slate-700 dark:text-slate-200">{{ amountPreview.subTotal | number:'1.2-2' }}</span>
                            </div>
                            <div class="flex justify-between text-[12px]">
                                <span class="text-slate-500 dark:text-slate-400">VAT {{ vatSetting.rateLabel() }}%</span>
                                <span class="font-bold text-slate-700 dark:text-slate-200">{{ amountPreview.vatAmount | number:'1.2-2' }}</span>
                            </div>
                            <div class="flex justify-between text-[13px] pt-2 border-t border-slate-200 dark:border-slate-700">
                                <span class="font-bold text-slate-600 dark:text-slate-300">ยอดรวมทั้งสิ้น</span>
                                <span class="font-black text-amber-600 dark:text-amber-400">{{ amountPreview.total | number:'1.2-2' }}</span>
                            </div>
                        </div>
                    </div>

                    <hr class="border-slate-100 dark:border-slate-700/60">

                    <!-- Delayed Payment -->
                    <div class="pt-2">
                        <label class="flex items-center gap-2 cursor-pointer group w-max">
                            <div class="relative flex items-center justify-center">
                                <input type="checkbox" [(ngModel)]="delayed" class="sr-only">
                                <div class="w-[18px] h-[18px] border-2 rounded-md flex items-center justify-center transition-all duration-300"
                                    [ngClass]="delayed ? 'bg-amber-500 border-amber-500 shadow-sm shadow-amber-500/25' : 'bg-white dark:bg-slate-800 border-slate-300 dark:border-slate-600 hover:border-amber-400 dark:hover:border-amber-500'">
                                    <svg class="w-3 h-3 text-white transition-transform duration-300" fill="none"
                                        viewBox="0 0 24 24" stroke="currentColor" stroke-width="4"
                                        [ngClass]="delayed ? 'scale-100' : 'scale-0'">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                                    </svg>
                                </div>
                            </div>
                            <div class="flex flex-col">
                                <span
                                    class="text-[13px] font-bold text-slate-700 dark:text-slate-200 select-none group-hover:text-amber-600 dark:group-hover:text-amber-400 transition-colors leading-tight">ชำระล่าช้า</span>
                                <span class="text-[11px] text-slate-400 font-medium">(Delayed Payment)</span>
                            </div>
                        </label>
                    </div>

                    <!-- Due Date -->
                    <div *ngIf="delayed"
                        class="animate-fade-in-up space-y-4 pl-8 border-l-2 border-slate-100 dark:border-slate-700 ml-2.5">
                        <div>
                            <label
                                class="block text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-1.5">วันครบกำหนดชำระ
                                (Due Date) <span class="text-rose-500">*</span></label>
                            <div class="relative">
                                <span
                                    class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-[18px]">calendar_month</span>
                                <input type="date" [(ngModel)]="dueDate" [max]="maxDate"
                                    class="w-full pl-9 pr-3 py-2.5 bg-white dark:bg-slate-800 border-2 border-slate-200 dark:border-slate-700 rounded-xl outline-none focus:ring-4 focus:ring-amber-500/10 focus:border-amber-400 dark:focus:border-amber-500 text-slate-700 dark:text-slate-200 text-sm font-medium transition-all [color-scheme:light] dark:[color-scheme:dark]">
                            </div>
                        </div>

                        <div *ngIf="checkDueDateDelay()" class="animate-fade-in">
                            <label
                                class="block text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-1.5">เลขที่ใบเสร็จ
                                (Receipt No.) <span class="text-rose-500">*</span></label>
                            <div class="relative">
                                <span
                                    class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-[18px]">receipt</span>
                                <input type="text" [(ngModel)]="receiptNo" placeholder="ระบุเลขที่ใบเสร็จ"
                                    class="w-full pl-9 pr-3 py-2.5 bg-white dark:bg-slate-800 border-2 border-slate-200 dark:border-slate-700 rounded-xl outline-none focus:ring-4 focus:ring-amber-500/10 focus:border-amber-400 dark:focus:border-amber-500 text-slate-700 dark:text-slate-200 text-sm font-medium transition-all placeholder:text-slate-400">
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Right Column: Tax Invoice & Details -->
            <div class="h-max space-y-5 md:space-y-6 flex flex-col justify-start">

                <div class="rounded-2xl p-4 md:p-5 transition-all duration-500 relative overflow-visible flex flex-col group/tax-card z-40"
                    [ngClass]="{
                        'bg-gradient-to-br from-amber-50 to-orange-50/50 dark:from-amber-900/20 dark:to-orange-900/10 border-2 border-amber-400/50 dark:border-amber-700/50 shadow-md shadow-amber-500/5 ring-4 ring-amber-500/5': taxInvoiceNeeded,
                        'bg-white dark:bg-slate-800 border-2 border-slate-100 dark:border-slate-700/60 shadow-sm hover:border-amber-200 dark:hover:border-slate-600': !taxInvoiceNeeded
                    }">
                    <div class="flex justify-between items-start mb-4">
                        <div class="flex items-center gap-3">
                            <div class="w-10 h-10 rounded-xl flex items-center justify-center transition-all duration-300 shadow-sm"
                                [ngClass]="taxInvoiceNeeded ? 'bg-amber-100 dark:bg-amber-900/40 text-amber-600 dark:text-amber-400 rotate-12' : 'bg-slate-100 dark:bg-slate-700/50 text-slate-400'">
                                <span class="material-icons text-[24px]">description</span>
                            </div>
                            <div class="flex flex-col">
                                <h3 class="text-sm font-bold leading-tight"
                                    [ngClass]="taxInvoiceNeeded ? 'text-amber-800 dark:text-amber-400' : 'text-slate-700 dark:text-slate-200'">
                                    ใบกำกับภาษีเต็มรูป</h3>
                                <p class="text-[11px] text-slate-400 mt-0.5">(Tax Invoice Detailed)</p>
                            </div>
                        </div>
                        <div (click)="selectedCustomerId !== null && taxInvoiceNeeded = !taxInvoiceNeeded"
                            class="relative w-11 h-6 rounded-full cursor-pointer transition-all duration-300 ring-4 ring-transparent hover:ring-slate-100 dark:hover:ring-slate-800"
                            [ngClass]="{
                                'bg-amber-500 shadow-inner shadow-amber-600/20': taxInvoiceNeeded,
                                'bg-slate-200 dark:bg-slate-700': !taxInvoiceNeeded,
                                'opacity-50 cursor-not-allowed': selectedCustomerId === null
                            }">
                            <div class="absolute top-1 left-1 w-4 h-4 bg-white rounded-full shadow-md transition-all duration-300 flex items-center justify-center"
                                [ngClass]="{'translate-x-5': taxInvoiceNeeded}">
                                <span
                                    class="material-icons text-[9px] text-amber-500 font-bold scale-0 transition-transform leading-none"
                                    [ngClass]="{'scale-70 pt-0.5': taxInvoiceNeeded}"
                                    style="display: flex; align-items: center; justify-content: center;">check</span>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="taxInvoiceNeeded" class="animate-fade-in-up space-y-4">
                        <div class="relative z-50">
                            <ng-container *ngTemplateOutlet="selectField; context: { 
                                label: 'ที่อยู่ออกใบกำกับภาษี', 
                                key: 'taxs', 
                                options: taxOptions, 
                                selected: selectedTaxAddressId, 
                                icon: 'home_work', 
                                placeholder: '-- เลือกที่อยู่ --',
                                disabled: false
                            }"></ng-container>
                        </div>
                        <div class="flex justify-end mt-2 relative z-0">
                            <button (click)="openFulltaxModal()"
                                class="text-xs font-bold text-amber-600 dark:text-amber-400 bg-white/50 dark:bg-slate-800/50 backdrop-blur-sm border border-amber-200 dark:border-amber-900/50 px-2.5 py-1.5 rounded-lg hover:bg-amber-100 dark:hover:bg-amber-900/50 hover:shadow-sm transition-all flex items-center gap-1.5 cursor-pointer">
                                <span class="material-icons text-[14px]">add</span> เพิ่มที่อยู่ใหม่
                            </button>
                        </div>
                    </div>
                    <div *ngIf="!taxInvoiceNeeded"
                        class="text-sm text-slate-400 dark:text-slate-500 font-medium italic text-center py-4 bg-slate-50 dark:bg-slate-800/50 rounded-xl border border-dashed border-slate-200 dark:border-slate-700 mt-2">
                        ไม่ต้องออกใบกำกับภาษี
                    </div>
                </div>

                <div class="relative z-30">
                    <label
                        class="block text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-1.5">
                        รายละเอียด (Description)
                    </label>
                    <textarea [(ngModel)]="description" rows="3" placeholder="ระบุรายละเอียดรายได้"
                        class="w-full px-3.5 py-2.5 bg-white dark:bg-slate-800 border-2 border-slate-200 dark:border-slate-700 rounded-xl outline-none focus:ring-4 focus:ring-amber-500/10 focus:border-amber-400 dark:focus:border-amber-500 text-slate-700 dark:text-slate-200 text-sm font-medium transition-all resize-y min-h-[80px] hover:border-amber-300 dark:hover:border-amber-500/50"></textarea>
                </div>

                <!-- Receipt Image Section -->
                <div class="relative z-20">
                    <label
                        class="block text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-1.5">
                        รูปภาพใบเสร็จ (Receipt Image) <span class="text-rose-500">*</span>
                    </label>

                    <div class="w-full">
                        <label for="dropzone-file" *ngIf="!receiptImage"
                            class="relative flex flex-col items-center justify-center w-full h-40 border-2 border-slate-300 dark:border-slate-600 border-dashed rounded-xl cursor-pointer bg-slate-50 dark:bg-slate-800/50 hover:bg-slate-100 dark:hover:bg-slate-800 hover:border-amber-400 dark:hover:border-amber-500 transition-all duration-300 group overflow-hidden">
                            <div class="flex flex-col items-center justify-center pt-5 pb-6">
                                <span
                                    class="material-icons text-4xl mb-3 text-slate-400 dark:text-slate-500 group-hover:text-amber-500 transition-colors">cloud_upload</span>
                                <p class="mb-1 text-[13px] text-slate-500 dark:text-slate-400 font-medium"><span
                                        class="font-bold text-slate-700 dark:text-slate-300">คลิกเพื่ออัปโหลด</span></p>
                                <p class="text-[11px] text-slate-400">PNG หรือ JPG (ไม่เกิน 5MB)</p>
                            </div>
                            <input id="dropzone-file" type="file" accept="image/png,image/jpeg,image/webp" class="hidden" (change)="onFileChange($event)" />
                        </label>

                        <div *ngIf="receiptImage"
                            class="relative group rounded-xl border-2 border-slate-200 dark:border-slate-700 overflow-hidden bg-slate-50 dark:bg-slate-800 flex justify-center items-center h-48">
                            <img [src]="receiptImage" alt="Receipt" class="h-full w-full object-contain p-2">
                            <div
                                class="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                                <button (click)="receiptImage = ''; receiptImageName = ''"
                                    class="bg-rose-500 text-white p-2 rounded-full hover:bg-rose-600 hover:scale-110 transition-all shadow-lg flex items-center justify-center cursor-pointer">
                                    <span class="material-icons text-[20px]">delete</span>
                                </button>
                            </div>
                        </div>
                        <div *ngIf="receiptImage"
                            class="mt-2 text-[11px] font-medium text-amber-600 dark:text-amber-400 flex items-center gap-1">
                            <span class="material-icons text-[14px]">check_circle</span>
                            <span class="truncate">{{ receiptImageName }}</span>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <!-- Action Buttons Footer -->
        <div class="px-4 md:px-6 py-5 bg-white dark:bg-slate-800 border-t border-slate-100 dark:border-slate-800/50 rounded-b-xl flex flex-col md:flex-row justify-end gap-3 relative z-10 animate-fade-in-up"
            style="animation-delay: 0.2s;">
            <button (click)="onCancel()"
                class="w-full md:w-auto px-6 py-2.5 bg-white dark:bg-slate-700 border-2 border-slate-200 dark:border-slate-600 rounded-xl text-[13px] font-bold text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-600 transition-colors shadow-sm focus:outline-none cursor-pointer tracking-wide">
                ยกเลิก
            </button>
            <button (click)="submit()" [disabled]="!canCreate"
                class="w-full md:w-auto px-8 py-2.5 bg-amber-400 hover:bg-amber-500 text-white rounded-xl text-[13px] font-bold shadow-lg shadow-amber-300/50 dark:shadow-none transition-all flex items-center justify-center gap-2 cursor-pointer transform hover:-translate-y-0.5 active:translate-y-0 tracking-wide relative overflow-hidden group disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:translate-y-0">
                <div
                    class="absolute inset-0 w-full h-full bg-white/20 -translate-x-full group-hover:animate-shimmer skew-x-12">
                </div>
                <span class="material-icons text-[18px]">save</span> บันทึกรายได้
            </button>
        </div>
    </div>
</div>

<!-- Reusable Dropdown Template -->
<ng-template #selectField let-label="label" let-key="key" let-options="options" let-selected="selected" let-icon="icon"
    let-placeholder="placeholder" let-disabled="disabled" let-required="required">
    <div class="relative w-full">
        <label class="block text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-1.5">
            {{ label }} <span *ngIf="required !== false && key !== 'invoices'" class="text-rose-500">*</span>
        </label>
        <div class="relative group" (click)="$event.stopPropagation();">
            <button type="button" (click)="!disabled && toggleDropdown(key, $event)" [disabled]="disabled"
                class="w-full flex items-center justify-between px-3 py-2 bg-white dark:bg-slate-800 border-2 rounded-xl text-left transition-all duration-200 focus:outline-none focus:ring-4 focus:ring-amber-500/10 shadow-[0_2px_10px_-3px_rgba(0,0,0,0.05)] text-[13px] font-medium min-h-[40px]"
                [ngClass]="{
                    'border-slate-200 dark:border-slate-700 hover:border-amber-400 dark:hover:border-amber-500': openDropdown !== key && !disabled,
                    'border-amber-400 dark:border-amber-500 ring-4 ring-amber-500/10 shadow-sm': openDropdown === key,
                    'bg-slate-50 border-slate-100 dark:border-slate-700/50 text-slate-400 cursor-not-allowed opacity-70': disabled,
                    'text-slate-700 dark:text-slate-200': selected !== null && !disabled,
                    'text-slate-400 dark:text-slate-500': selected === null && !disabled
                }">
                <div class="flex items-center gap-2 limit-text w-full">
                    <div class="w-6 h-6 rounded-md flex items-center justify-center transition-colors shadow-sm flex-shrink-0"
                        [ngClass]="selected !== null ? 'bg-amber-100 dark:bg-amber-900/40 text-amber-600 dark:text-amber-400' : 'bg-slate-100 dark:bg-slate-700 text-slate-400'">
                        <span class="material-icons text-[14px]">{{ icon }}</span>
                    </div>
                    <span class="truncate block overflow-hidden text-ellipsis whitespace-nowrap"
                        style="max-width: calc(100% - 24px);">{{ getOptionName(key, selected) || placeholder }}</span>
                </div>
                <span
                    class="material-icons text-slate-400 transition-transform duration-300 text-[18px] ml-1 flex-shrink-0"
                    [ngClass]="{'rotate-180 text-amber-500': openDropdown === key}">expand_more</span>
            </button>

            <div *ngIf="openDropdown === key && !disabled"
                class="absolute z-[100] w-full mt-1.5 bg-white/95 dark:bg-slate-800/95 backdrop-blur-xl border border-slate-200/80 dark:border-slate-700/80 rounded-xl shadow-[0_10px_40px_-10px_rgba(0,0,0,0.15)] py-1.5 max-h-56 overflow-y-auto transform opacity-100 scale-100 transition-all origin-top custom-scrollbar animate-fade-in-up">
                <button *ngIf="!options || options.length === 0" disabled
                    class="w-full text-left px-3 py-2 text-[12px] text-slate-400 italic">
                    ไม่มีข้อมูล
                </button>
                <button *ngFor="let option of options"
                    (click)="selectOption(key, option.value); $event.stopPropagation();"
                    class="w-full text-left px-3 py-2.5 text-[12px] transition-colors flex items-center justify-between group"
                    [ngClass]="{
                        'bg-amber-50/80 dark:bg-amber-900/20 text-amber-700 dark:text-amber-400 font-bold': selected === option.value,
                        'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-slate-800 dark:hover:text-slate-100 font-medium': selected !== option.value
                    }">
                    <span class="truncate pr-2 block overflow-hidden text-ellipsis">{{ option.label }}</span>
                    <span *ngIf="selected === option.value"
                        class="material-icons text-[16px] text-amber-500 animate-scale-up flex-shrink-0">check_circle</span>
                </button>
            </div>
        </div>
    </div>
</ng-template>

<app-modal-fullltax-form *ngIf="isFulltaxModalOpen" [customerId]="selectedCustomerId || 0" (close)="closeFulltaxModal()"
    (save)="saveFulltaxModal()"></app-modal-fullltax-form>

<!-- Confirm Modal (Modernized) -->
<div *ngIf="isConfirmModalOpen" class="fixed inset-0 z-50 flex items-center justify-center p-4">
    <div class="absolute inset-0 bg-black/50 backdrop-blur-sm transition-opacity" (click)="closeConfirmModal()"></div>

    <div
        class="relative bg-white dark:bg-slate-800 rounded-2xl shadow-2xl w-full max-w-md overflow-hidden animate-fade-in-up border border-gray-100 dark:border-slate-700">
        <div class="p-6 text-center">
            <div
                class="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-blue-50 dark:bg-blue-900/30 mb-6 relative overflow-hidden">
                <div class="absolute inset-0 bg-amber-400/20 animate-pulse"></div>
                <span class="material-icons text-4xl text-amber-500 relative z-10">info</span>
            </div>

            <h3 class="text-xl font-bold text-gray-900 dark:text-slate-100 mb-2">ยืนยันการบันทึกรายได้?</h3>
            <p class="text-sm text-gray-500 dark:text-slate-400 mb-6 flex flex-col items-center">
                <span>คุณต้องการบันทึกข้อมูลรายได้ยอดรวม</span>
                <span class="font-black text-amber-600 dark:text-amber-400 text-lg mt-1">{{ confirmGrandTotal | number:'1.2-2'
                    }} บาท</span>
                <span *ngIf="amountPreview.vatAmount > 0" class="text-xs text-slate-400 mt-1">
                    (ฐาน {{ amountPreview.subTotal | number:'1.2-2' }} + VAT {{ amountPreview.vatAmount | number:'1.2-2' }})
                </span>
            </p>

            <div class="grid grid-cols-2 gap-3">
                <button (click)="closeConfirmModal()"
                    class="w-full px-4 py-2.5 bg-white dark:bg-slate-700 border border-slate-200 dark:border-slate-600 rounded-xl text-sm font-bold text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-600 transition-colors shadow-sm focus:outline-none cursor-pointer">
                    ยกเลิก
                </button>
                <button (click)="confirmSave()" [disabled]="isLoading"
                    class="w-full px-4 py-2.5 bg-amber-400 hover:bg-amber-500 text-white rounded-xl text-sm font-bold shadow-[0_4px_15px_rgb(251,191,36,0.3)] hover:shadow-[0_8px_25px_rgb(251,191,36,0.4)] transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2 cursor-pointer">
                    <span *ngIf="isLoading"
                        class="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></span>
                    <span>{{ isLoading ? 'กำลังบันทึก...' : 'ยืนยัน' }}</span>
                </button>
            </div>
        </div>
    </div>
</div>

<app-pss-loading *ngIf="isLoading"></app-pss-loading>